import { render, staticRenderFns } from "./create-new-business-form.vue?vue&type=template&id=80da7566&"
import script from "./create-new-business-form.vue?vue&type=script&lang=js&"
export * from "./create-new-business-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports